// Dependencies
import React, { useState } from 'react';
import { navigate } from 'gatsby';
import PropTypes from 'prop-types';

// Components
import Container from '../../container/container';
import InputFactory from '../../forms/inputFactory/inputFactory';
import FormError from '../../forms/formError/formError';

// Validators
import validateReferYourFriend from '../../../validators/referYourFriend';

// Styles
import ReferFriendFormFormStyles from './referYourFriendForm.styles';

export default function ReferYourFriendForm({ layout }) {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    telephone: '',
    referredBy: '',
    referAFriend: '',
  });
  const [formDataErrors, setFormDataErrors] = useState({});
  const [formError, setFormError] = useState(false);
  const [submitDisabled, setSubmitDisabled] = useState(false);

  const validate = () => {
    setFormDataErrors({});

    const validatedReferYourFriend = validateReferYourFriend(formData);

    if (!validatedReferYourFriend?.success) {
      setSubmitDisabled(false);

      if (validatedReferYourFriend?.errors) {
        setFormDataErrors(validatedReferYourFriend?.errors);
      } else {
        setFormError(true);
      }

      return false;
    }

    return true;
  };

  const sendToMonday = async () => {
    const request = await fetch(
      `${process.env.GATSBY_SITE_URL}/api/refer-your-friend/create-item`,
      {
        method: 'POST',
        body: JSON.stringify({
          ...formData,
        }),
      },
    ).then((res) => res.json());

    if (!request?.success) {
      setFormError(true);
      setSubmitDisabled(false);

      return false;
    }

    return true;
  };

  const sendBackupEmail = () => {
    fetch(`${process.env.GATSBY_SITE_URL}/api/emails/refer-your-friend/admin`, {
      method: 'POST',
      body: JSON.stringify({
        formData,
      }),
    }).then(() => {});
  };

  const sendAutoresponder = () => {
    fetch(`${process.env.GATSBY_SITE_URL}/api/emails/refer-your-friend/user`, {
      method: 'POST',
      body: JSON.stringify({
        formData,
      }),
    }).then(() => {});
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!submitDisabled) {
      const validates = validate();

      if (validates) {
        setSubmitDisabled(true);

        sendBackupEmail();
        sendAutoresponder();

        if (await sendToMonday()) await navigate('/thank-you');
      }
    }
  };

  const handleChange = (event, actionMeta) => {
    const { value } = event?.target || event;
    const { name } = event?.target || actionMeta || '';

    setFormData((fields) => ({
      ...fields,
      [name]: value,
    }));
  };

  const heading = layout?.heading;

  return (
    <ReferFriendFormFormStyles>
      <Container>
        <form
          onSubmit={handleSubmit}
          encType="multipart/form-data"
          className="form"
        >
          {heading && (
            <div className="form-header">
              <h2 className="heading">{heading}</h2>
            </div>
          )}
          <div className="form-body">
            <InputFactory
              type="text"
              name="firstName"
              placeholder="First Name"
              required
              value={formData?.firstName}
              onChange={handleChange}
              error={formDataErrors?.firstName}
            />

            <InputFactory
              type="text"
              name="lastName"
              placeholder="Last Name"
              required
              value={formData?.lastName}
              onChange={handleChange}
              error={formDataErrors?.lastName}
            />

            <InputFactory
              type="email"
              name="email"
              placeholder="Email"
              required
              value={formData?.email}
              onChange={handleChange}
              error={formDataErrors?.email}
            />

            <InputFactory
              type="text"
              name="telephone"
              placeholder="Telephone"
              required
              value={formData?.telephone}
              onChange={handleChange}
              error={formDataErrors?.telephone}
            />

            <InputFactory
              type="text"
              name="referredBy"
              placeholder="Referred By"
              required
              value={formData?.referredBy}
              onChange={handleChange}
              error={formDataErrors?.referredBy}
            />

            <InputFactory
              type="select"
              id="referAFriend"
              label="Are you filling this in on behalf of a friend?"
              name="referAFriend"
              required
              onChange={handleChange}
              options={[
                {
                  label: 'Yes and I wish to remain anonymous',
                  value: 'Wishes to Remain Anonymous',
                },
                {
                  label:
                    'Yes and I’m happy for my friend to know I referred them',
                  value: 'Happy for Friend to Know',
                },
                {
                  label: 'No I am filling it in with my own details',
                  value: 'Own Details',
                },
              ]}
              value={formData?.referAFriend}
              error={formDataErrors?.referAFriend}
            />
          </div>

          <footer className="form-footer">
            {formError && <FormError />}

            <button
              type="submit"
              className="btn dark"
              disabled={submitDisabled}
            >
              Submit
            </button>
          </footer>
        </form>
      </Container>
    </ReferFriendFormFormStyles>
  );
}

ReferYourFriendForm.propTypes = {
  layout: PropTypes.shape({
    heading: PropTypes.string,
  }),
};

ReferYourFriendForm.defaultProps = {
  layout: {
    heading: '',
  },
};
